import { FC } from "react";
import type { Raffle } from "../model/types";
import { ConditionIcon } from "./ConditionIcon";
import { formatRaffleDate } from "./formatRaffleDate";
import { IconBox } from "./IconBox";

import styles from "./RaffleTimeline.module.css";

interface Props {
  raffle: Raffle;
}

const Edge: FC<{ label: string; iso: string; end?: boolean }> = ({
  label,
  iso,
  end = false,
}) => (
  <div className={`${styles.edge} ${end ? styles.end : ""}`}>
    <IconBox>
      <ConditionIcon name="calendar" />
    </IconBox>
    <div className={styles.text}>
      <span className={styles.label}>{label}</span>
      <span className={styles.date}>{formatRaffleDate(iso)}</span>
    </div>
  </div>
);

// Начало и конец розыгрыша, соединённые линией.
export const RaffleTimeline: FC<Props> = ({ raffle }) => (
  <div className={styles.timeline}>
    <Edge label="Starts" iso={raffle.starts_at} />
    <span className={styles.line} aria-hidden="true" />
    {raffle.drawn_at ? (
      <Edge label="Drawn" iso={raffle.drawn_at} end />
    ) : (
      <Edge label="Ends" iso={raffle.ends_at} end />
    )}
  </div>
);
